import * as React from "react";
function SvgUnplug(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      ref={svgRef}
      {...props}
    >
      <path d="M47.1 14.3l-5.5-5.6L46 4.2 43.7 2l-4.5 4.5L33.7.9c-1.2-1.2-3.2-1.3-4.5 0l-6.7 6.7-1.1-1.1c-.6-.6-1.6-.6-2.2 0-.6.6-.6 1.6 0 2.2l1.1 1.1 3.4 3.4c-.1.1-.3.2-.4.3L18.9 18c-.6.6-.6 1.6 0 2.2.6.6 1.6.6 2.2 0l4.5-4.5c.1-.1.2-.2.3-.4l6.8 6.8c-.1.1-.3.2-.4.3l-4.5 4.5c-.6.6-.6 1.6 0 2.2.6.6 1.6.6 2.2 0l4.5-4.5c.1-.1.2-.2.3-.4l3.4 3.4 1.1 1.1c.6.6 1.6.6 2.2 0 .6-.6.6-1.6 0-2.2l-1.1-1.1 6.7-6.7c1.2-1.2 1.2-3.2 0-4.4zm-8.9 8.9l-1.7-1.7L24.8 9.8l6.7-6.7 13.4 13.4-6.7 6.7zM8.7 19.3c-.6-.6-1.6-.6-2.2 0-.6.6-.6 1.6 0 2.2l1.1 1.1-6.7 6.7c-1.2 1.2-1.3 3.2 0 4.5l5.6 5.6-5.1 4.9 2.3 2.2 5-5 5.6 5.6c1.2 1.2 3.2 1.3 4.5 0l6.6-6.6 1.1 1.1c.6.6 1.6.6 2.2 0 .6-.6.6-1.6 0-2.2l-20-20.1zm7.8 25.6L3.2 31.5l6.7-6.7 13.3 13.3-6.7 6.8z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgUnplug);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
